
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.972 15.341L12 9.941l-5.972 5.4a.616.616 0 01-.869-.042.613.613 0 01.043-.867l6.385-5.773a.616.616 0 01.826 0l6.385 5.773a.613.613 0 01.043.867.616.616 0 01-.869.042z"}})])
          )
        }
      }
    